import { render, staticRenderFns } from "./lucklog.vue?vue&type=template&id=384b0d3b&scoped=true"
import script from "./lucklog.vue?vue&type=script&lang=js"
export * from "./lucklog.vue?vue&type=script&lang=js"
import style0 from "./lucklog.vue?vue&type=style&index=0&id=384b0d3b&prod&scoped=true&lang=css"
import style1 from "./lucklog.vue?vue&type=style&index=1&id=384b0d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b0d3b",
  null
  
)

export default component.exports